import Grid from '@mui/material/Grid';
import React, { Suspense } from 'react';
import KeenSliderWrapper from '../../styles/keen-slider';

const Summary = React.lazy(() => import('../../views/dashboard/Summary'));
const SalesYear = React.lazy(() => import('../../views/dashboard/SalesYear'));
const SalesMonth = React.lazy(() => import('../../views/dashboard/SalesMonth'));
const Performance = React.lazy(() => import('../../views/dashboard/Performance'));
const Metricbar = React.lazy(() => import('../../views/dashboard/Metricbar'));
const AccessChart = React.lazy(() => import('../../views/dashboard/AccessChart'));

const Dashboard = () => {
    return (
        <KeenSliderWrapper>
            <Grid container spacing={6} className='match-height'>
                <Grid item xs={12}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Summary />
                    </Suspense>
                </Grid>
                <Grid item xs={12} mt={8}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <SalesYear />
                    </Suspense>
                </Grid>
                <Grid item xs={12} mt={8}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <SalesMonth />
                    </Suspense>
                </Grid>
                <Grid item xs={12} mt={8}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Performance />
                    </Suspense>
                </Grid>
                <Grid item sm={12} md={6} lg={3}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Metricbar title={"당월 견적 TOP10"} fill="#00C49F" target={"spec"} />
                    </Suspense>
                </Grid>
                <Grid item sm={12} md={6} lg={3}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Metricbar title={"당월 매출 TOP10"} fill="#008060" target={"sales"} />
                    </Suspense>
                </Grid>
                <Grid item sm={12} md={12} lg={6}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <AccessChart />
                    </Suspense>
                </Grid>
            </Grid>
        </KeenSliderWrapper>
    )
}

export default Dashboard